import { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'

import { App } from './pages/app'
import Login from './pages/login'
import NotFound from './pages/notfound'
import Debug from './pages/debug'
import { applyTheme } from './state/theme'
import { queryClient } from './queries/client'
import './index.css'

function Index() {
  useEffect(() => {
    applyTheme((window.localStorage.theme as Parameters<typeof applyTheme>[0]) || 'light')
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/debug" element={<Debug />} />
          <Route path="/*" element={<App />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

createRoot(document.getElementById('root')!).render(<Index />)
